import React, { useState, useLayoutEffect, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Box, IconButton, Typography, Divider } from "@mui/material";
import { Images } from "../../assets/common";
import live_Button from "../../assets/common/resources/sidenav/live_button.svg"; // Assuming this is the live button image

import { hasPremium } from './../../constants/function';
import "./index.scss";
import { logout } from "../../constants/function";
import { Stack } from "@mui/material";
import AddPopup from "../AddPopup";
import BiddingPopup from "../BiddingPopup";
import OutsideClickHandler from "react-outside-click-handler";
import ApiService from "../../services/api-service";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../action/language";
import cookieStorage from "../../services/cookie-storage";
import { Flags } from 'react-feature-flags';
import SkNavBar from '../SkNavBar/SkNavBar';
import LeftBarUpload from './LeftBarUpload';
import LeftBarMenuBox from './LeftBarMenuBox';
import LeftBarAuction from './LeftBarAuction';
import SubscriptionPopup from "../SubscriptionPopup"; // Import your subscription popup


export default function LeftBar({ isNavOpen, toggleNavOpen, switchSection }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation("common");

  const { availableLanguages, language } = useSelector((state) => state.language);
  const [nft, setNft] = React.useState(null);
  const [auctionHouse, setAuctionHouse] = React.useState({});
  const [bidding, setBidding] = React.useState(false);
  const [auction, setAuction] = React.useState(false);
  const [addPlaylist, setAddPlayList] = React.useState(false);
  const [menu, setMenu] = React.useState(false);
  const [menuLang, setMenuLang] = React.useState(false);
  const [index, setIndex] = React.useState(0);
  const [isPremium, setPremium] = React.useState(false);
  const [showPremiumPopup, setShowPremiumPopup] = useState(false);



  const handleLogout = () => {
    logout();
    history.push("/");
  };

  React.useEffect(() => {
    setPremium(hasPremium()); 
  }, [history.location.pathname]);

  React.useEffect(() => {
    getAuctions();
    setIndex(
      history.location.pathname.includes("/app/Home")
        ? 0
        : history.location.pathname === "/app/MyMusic"
        ? 1
        : history.location.pathname.includes("/app/Playlists") ||
          history.location.pathname.includes("/app/PlaylistStatics/")
        ? 2
        : history.location.pathname === "/app/Albums" ||
          history.location.pathname.includes("/app/MyAlbumDetail/")
        ? 3
        : history.location.pathname === "/app/Nft/music" ||
          history.location.pathname === "/app/Nft/studio"
        ? 4
        : history.location.pathname === "/app/Subscription"
        ? 5
        : history.location.pathname === "/app/UnlockedAssets/Music" ||
          history.location.pathname === "/app/UnlockedAssets/Playlist"
        ? 6
        : null
    );
  }, [history.location.pathname]);

    // Handle opening the premium subscription popup
    const handleUpgradeClick = () => {
      setShowPremiumPopup(true);
    };

  const handleBiding = (nft) => {
    setNft(nft);
    setBidding(true);
  };

  const handleAuction = async (nft) => {
    setNft(nft);
    setAuction(true);
  };

  const getAuctions = async () => {
    try {
      const response = await ApiService.BID_AND_AUCTIONS();
      setAuctionHouse({ ...response["result"] });
    } catch (error) {}
  };

  const handleLiveStreamClick = () => {
    history.push("/app/Playlists");
  };

  const handleLangChange = async (language) => {
    setMenuLang(false);
    try {
      const response = await ApiService.LANGUAGE(`language=${language}&class=web`);
      const { availableLanguages, languageObject, selectedLanguage, token } = response.result;
      if (token) cookieStorage.createCookie("Authorization", token, 1);

      dispatch(
        setLanguage({
          language: selectedLanguage,
          languageObject: languageObject,
          availableLanguages: availableLanguages,
        })
      );
      window.location.reload();
    } catch (error) {}
  };

  const getCode = () => {
    const lng = availableLanguages.filter(
      (available) => available.code === language
    );
    if (lng.length > 0) return lng[0].language;
    else return "";
  };

  return (
    <Box sx={{ display: "flex" }}>
      {/* Sidebar */}
      <Box
        id="sideBarOuter"
        sx={{
          position: "fixed", // Sidebar stays fixed
          top: "20%",
          left: 0, // Align to the left
          height: "100vh", // Full height
          width: "110px", // Sidebar width
          backgroundColor: "black", // Sidebar background
          zIndex: 1, // Ensure it's on top
        }}
      >
        {/* Sidebar Content */}
        {isNavOpen && (
          <Box
            id="sideBarInner"
            sx={{
              height: "100%", // Full height for inner content
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start", // Align items at the top
              alignItems: "center", // Center horizontally
              padding: "20px 0", // Padding for inner content
              overflowY: "auto", // Allow scrolling within the sidebar
            }}
          >
            <Flags
              authorizedFlags={["v3-full", "v3-navBar"]}
              renderOn={() => <SkNavBar switchSection={switchSection} />}
              renderOff={() => (
                <>
                  <LeftBarUpload
                    menu={menu}
                    toggleNav={toggleNavOpen}
                    setMenu={setMenu}
                    setAddPlayList={setAddPlayList}
                  />
                  <IconButton
                    onClick={handleLiveStreamClick}
                    sx={{ width: "70px", height: "70px", marginTop: "20px" }}
                  >
                    <img src={live_Button} alt="Live Button" style={{ width: "100%", height: "100%" }} />
                  </IconButton>
                  
                  <LeftBarMenuBox
                    index={index}
                    setIndex={setIndex}
                    toggleNav={toggleNavOpen}
                    isPremium={isPremium}
                  />
                  <LeftBarAuction 
                  auctionHouse={auctionHouse} 
                  handleBiding={handleBiding} 
                  handleAuction={handleAuction} 
                  />

                </>
              )}
            />
          </Box>
        )}
      </Box>

      {/* Main Content Area */}
      <Box
        sx={{
          marginLeft: "5px", // Ensure content is pushed to the right of the sidebar
          padding: "50px",     // Padding for the main content
          width: "calc(100% - 110px)", // Remaining width after sidebar
          overflowX: "auto",    // Enable horizontal scrolling within the content area
        }}
      >
      </Box>

      {addPlaylist ? (
        <AddPopup
          api="playlist"
          title={t("addPopup.title1")}
          open={addPlaylist}
          handleClose={(e, close) => {
            setAddPlayList(close);
            setMenu(false);
          }}
        />
      ) : null}

      {bidding ? (
        <OutsideClickHandler onOutsideClick={() => setBidding(false)}>
          <BiddingPopup
            nft={nft}
            handleClose={() => setBidding(false)}
            isAuction={false}
          />
        </OutsideClickHandler>
      ) : null}

      {auction ? (
        <OutsideClickHandler onOutsideClick={() => setAuction(false)}>
          <BiddingPopup
            nft={nft}
            isAuction={true}
            handleClose={() => setAuction(false)}
          />
        </OutsideClickHandler>
      ) : null}

    </Box>
  );
}
